import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export default function FloatPercentFormatInput(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalSeparator=","
            thousandSeparator="."
            isNumericString={true}
            decimalScale={2}
            fixedDecimalScale={true}
            suffix={'%'}
        />
    );
};

FloatPercentFormatInput.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};